<template>
  <div>
    <b-card class="cardStyle">
      <div v-if="!loading">
        <section v-if="!firstTimeCard">
          <app-status-table :busy="busy" :requests="requests"></app-status-table>
          <b-row>
            <b-col class="my-access-custom-text-center float-right" cols="12">
              <b-button
                :disabled="busy"
                class="custom-float-right mt-3 px-4 manage-access-button-text"
                pill
                variant="primary"
                @click="toManageAccess()"
              >
                Manage my Access
              </b-button>
            </b-col>
          </b-row>
        </section>
        <section v-if="firstTimeCard">
          <div class="text-center my-5">
            <b-img :src="image" fluid></b-img>
          </div>
          <div class="first-time-card-text">
            <p class="mb-0">You have not submitted any application access requests.</p>
            <b-link @click="toManageAccess()"> Create your first access request</b-link>
            <p class="mt-4">
              Need help? Check our guide on how to make an application access request
            </p>
          </div>
        </section>
      </div>
      <div v-if="loading" id="loading" class="text-center">
        <b-spinner type="grow" label="Spinning" class="align-middle"></b-spinner>
        <div class="mt-2">
          <strong>Loading...</strong>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
  import { newStatusMap } from '../../utility/CommonFunctions';
  import img from '../../../../../public/images/accessRequest.png';
  import tableFieldsMixin from '../../mixins/tableFieldsMixin';
  import AppStatusTable from './AppStatusTable';

  export default {
    mixins: [tableFieldsMixin],
    components: {
      AppStatusTable,
    },
    props: {
      siteId: String,
      studyId: String,
      canManageAccess: Boolean,
      studySite: Object,
    },
    data() {
      return {
        image: img,
        firstTimeCard: false,
        requests: [],
        busy: false,
        loading: false,
      };
    },
    watch: {
      $route() {
        this.requests = [];
        this.getMyAccessRequestTickets();
      },
    },
    created() {
      this.getMyAccessRequestTickets();
    },
    methods: {
      newStatusMap,
      toManageAccess() {
        if (!this.canManageAccess) {
          this.$emit('redirectToOldCAM');
          return;
        }
        this.$store.commit('setUserDetails', {
          phoneNumber: '',
          firstName: window['Laravel']['user_firstName'],
          lastName: window['Laravel']['user_lastName'],
          selectedEmail: window['Laravel']['user_email'],
        });
        this.$emit('showManageRequest');
      },
      async getMyAccessRequestTickets() {
        try {
          this.busy = true;
          this.loading = true;
          let response = await axios.get(`/api/get-access-requests`, {
            params: {
              study_id: this.studyId,
              site_number: this.siteId,
              email: window['Laravel']['user_email'],
            },
          });
          if (response.status !== 204) {
            this.firstTimeCard = response.data['items'].length <= 0;
            response.data['items'].forEach(element => {
              element.childrequests.forEach(item => {
                this.requests.push(item);
              });
            });
            this.requests = this.requests.map(element => {
              if (element['systemRole'] !== null) {
                let description = element['systemRole']
                  .split('-', 1)
                  .slice(1)
                  .join('-');
                element['systemRole'] = element['systemRole'].split('-', 1)[0];
                element['description'] = description;
                let changedBy = element['changedBy'].toUpperCase();
                if (changedBy.includes('ALTERYX')) {
                  element['changedBy'] = 'Pfizer';
                }
              }
              let statusMap = this.newStatusMap(element.status, element.pendingReason);
              element['statusMap'] = statusMap.toUpperCase();
              return element;
            });
            this.$emit('myAccessRequests', this.requests);
          }
        } catch (error) {
          console.error(error);
        }
        this.busy = false;
        this.loading = false;
      },
    },
  };
</script>
<style>
  .first-time-card-text {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #383838;
  }

  .view-access-request {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #4040d7;
  }

  .manage-access-button-text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #ffffff;
  }
</style>
